// flow
import { createSelector } from "reselect"
import * as R from "ramda"

import { isKiwiBranding } from "../utils/isKiwiBranding"
import { iGet } from "../../utils/immutable"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const optionsSelector = (state: any) => state.options

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getPropertyDeep = (property: any, valueToGet: any) => (options: any) =>
  options.getIn(["branding", "contacts", property, "enabled"])
    ? options.getIn([
        "branding",
        "contacts",
        property,
        "locales",
        options.get("language"),
        valueToGet,
      ]) || options.getIn(["branding", "contacts", property, "locales", "default", valueToGet])
    : ""

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/restrict-template-expressions
const prependPlus = (x: any) => (x ? `+${x}` : x)

// SELECTORS
export const brandingSelector = createSelector(optionsSelector, (x) => x.branding)
export const brandingIdSelector = createSelector(brandingSelector, iGet("id"))
export const brandingNameSelector = createSelector(brandingSelector, iGet("name"))
export const brandingCompanyNameSelector = createSelector(brandingSelector, iGet("company_name"))

// @ts-expect-error: Flow to TS migration.
export const poweredByKiwiSelector: () => boolean = createSelector(
  brandingSelector,
  iGet("powered_by_kiwi"),
)

const phoneFromOptions = R.compose(prependPlus, getPropertyDeep("phones", "number"))
const emailFromOptions = getPropertyDeep("emails", "email")

// @ts-expect-error: Flow to TS migration.
export const homeRedirectUrlSelector: () => string = createSelector(
  brandingSelector,
  iGet("home_redirect_url"),
)

// CONTACTS
// @ts-expect-error: Flow to TS migration.
export const supportPhoneSelector: () => string = createSelector(optionsSelector, phoneFromOptions)
// @ts-expect-error: Flow to TS migration.
export const supportEmailSelector: () => string = createSelector(optionsSelector, emailFromOptions)

// @ts-expect-error: Flow to TS migration.
export const isPhoneEnabledSelector: () => boolean = createSelector(
  brandingSelector,
  iGet(["contacts", "phones", "enabled"]),
)
// @ts-expect-error: Flow to TS migration.
export const getPhones: () => boolean = createSelector(
  brandingSelector,
  iGet(["contacts", "phones", "locales"]),
)

export const isKiwiBrandingSelector = createSelector(brandingSelector, (branding) =>
  isKiwiBranding(branding),
)

export const mobileAppsSelector = createSelector(
  brandingSelector,
  iGet(["content", "promotion", "mobile_apps"]),
)

export const helpcenterApiUrlSelector = createSelector(
  brandingSelector,
  iGet(["api", "helpcenter"]),
)
